import { CSSObject } from '@chakra-ui/react';

export const BetSlipEmptyContainer: CSSObject = {
  justifyContent: 'flex-start',
  pt: '18',
  textAlign: 'center',
  mx: 'auto',
  w: 'full',
};

export const BetSlipEmptyHeading: CSSObject = {
  fontWeight: 'normal',
  fontSize: '3xl',
  lineHeight: '1',
  color: 'gamma.400',
  fontFamily: 'Chewy',
  textTransform: 'uppercase',
  w: '180px',
};

export const BetSlipEmptySubheading: CSSObject = {
  fontWeight: 'medium',
  fontSize: 'sm',
  color: 'white',
  my: '2',
};

export const BoxHeadingIconContainer: CSSObject = {
  display: 'flex',
  flexDir: 'column-reverse',
};
